import { Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { useScrollReveal } from "@/canvas/scene-runtime";
import { EarlyAccessProvider } from "@/components/EarlyAccessModal/context";
import { Footer } from "@/components/Layout/Footer";
import { Header } from "@/components/Layout/Header";
import { ScrollHint } from "@/components/ScrollHint";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export function RouteError({ error }: { error: Error }): ReactNode {
	const { t } = useTranslation();
	return (
		<main style={{ padding: 24, fontFamily: "system-ui" }}>
			<h1>{t("common.errorTitle")}</h1>
			<pre style={{ whiteSpace: "pre-wrap" }}>{error.message}</pre>
		</main>
	);
}

export function RootLayout(): ReactNode {
	useScrollReveal();
	useDocumentMeta();

	return (
		<EarlyAccessProvider>
			<Header />
			<Outlet />
			<Footer />
			<ScrollHint />
		</EarlyAccessProvider>
	);
}
